module.exports = __webpack_public_path__ + "img/fn-up-mask.7c44f318.png";